import styled from 'styled-components';
import palette from "../../Pallete";

export default styled.img`

display:block;
max-width: 100%;
height:auto;
/* width:389px; */
margin:40px 40px 40px 40px;
/* :hover{
    position:absolute;
    border:1px solid black;
    cursor:pointer;
    background-color:${palette.color.primary.main};
    opacity: .5;
    cursor: pointer;
    -o-transition: .1s;
    -ms-transition: .1s;
    -moz-transition: .1s;
    -webkit-transition: .1s;
    transition: .1s;
} */
`